{
  "author": "Matthias Goetzke <m.goetzke@curasystems.de>",
  "bin": {
    "aeppic-cert": "bin/new-cert.cjs",
    "aeppic-files": "bin/aeppic-files.js",
    "aeppic-server": "bin/aeppic-server.js"
  },
  "config": {
    "docker": {
      "tag": "registry.dev.curasystems.com/aeppic/aeppic-full/server:dev"
    },
    "email": "support@aeppic.com",
    "filter": "test/server/*.spec.js"
  },
  "dependencies": {
    "@aeppic-packages/workflow": "workspace:~4.45.0",
    "@aeppic/api": "workspace:~3.206.38",
    "@aeppic/component-preload": "0.1.0",
    "@aeppic/execution-scheduler": "workspace:^3.206.38",
    "@aeppic/read-model-browser": "0.2.3",
    "@aeppic/report-builder": "workspace:^3.50.2",
    "@aeppic/service-worker": "0.1.0",
    "@aeppic/shared": "workspace:~1.104.0",
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/exporter-metrics-otlp-grpc": "^0.211.0",
    "@opentelemetry/exporter-metrics-otlp-http": "^0.211.0",
    "@opentelemetry/resources": "^2.5.0",
    "@opentelemetry/sdk-metrics": "^2.5.0",
    "@opentelemetry/semantic-conventions": "^1.39.0",
    "@playwright/test": "1.34.2",
    "@sqlite.org/sqlite-wasm": "~3.42.0-build1",
    "@tailwindcss/aspect-ratio": "~0.4.2",
    "@tailwindcss/forms": "~0.5.10",
    "@tailwindcss/postcss": "~4.1.11",
    "@tailwindcss/typography": "~0.5.16",
    "@tailwindplus/elements": "~1.0.0",
    "@ungap/structured-clone": "~1.3.0",
    "acorn": "~8.15.0",
    "aeppic": "workspace:~3.206.38",
    "ajv-keywords": "^3.4.0",
    "better-sqlite3": "9.4.0",
    "body-parser": "^1.18.3",
    "chokidar": "~3.5.3",
    "cli-progress": "~3.12.0",
    "compression": "^1.7.3",
    "cookie-parser": "^1.4.4",
    "css-tree": "~3.1.0",
    "es6-promise": "^4.2.6",
    "etag": "~1.8.1",
    "express": "^4.16.4",
    "express-pino-logger": "~4.0.0",
    "express-session": "^1.15.6",
    "extract-text-webpack-plugin": "^3.0.2",
    "fast-safe-stringify": "~2.0.7",
    "ip-range-check": "~0.2.0",
    "less": "~4.4.0",
    "line-by-line": "^0.1.6",
    "lru-cache": "^4.1.5",
    "mkdirp": "^0.5.1",
    "moo": "~0.5.1",
    "nconf": "~0.12.0",
    "node-fetch": "^2.3.0",
    "node-toobusy": "~0.6.3",
    "pino": "~5.16.0",
    "pino-pretty": "^2.6.0",
    "postcss": "~8.4.23",
    "postcss-safe-parser": "~7.0.1",
    "pretty-bytes": "~6.1.0",
    "prom-client": "~13.2.0",
    "prometheus-api-metrics": "~3.2.0",
    "read-pkg": "~7.0.0",
    "requirejs": "^2.3.6",
    "rimraf": "~3.0.2",
    "selfsigned": "^1.10.6",
    "serve-favicon": "^2.5.0",
    "shelljs": "~0.8.4",
    "tailwindcss": "~4.1.11",
    "tar": "^4.4.8",
    "temp": "~0.9.1",
    "url-pattern": "^1.0.3",
    "vue": "2.7.14",
    "vue-router": "^2.8.1",
    "vue-template-compiler": "2.7.14",
    "write-file-atomic": "~3.0.1",
    "ws": "^5.2.2",
    "yargs": "~17.7.2",
    "yauzl": "^2.10.0"
  },
  "description": "Aeppic Server",
  "devDependencies": {
    "@aeppic/package": "workspace:~4.44.0",
    "@playwright/test": "1.34.2",
    "c8": "~8.0.1",
    "cross-env": "~7.0.3",
    "cross-var": "^1.1.0",
    "dexnode": "~1.2.1",
    "esbuild": "~0.17.12",
    "flamebearer": "~1.1.3",
    "get-port": "~6.0.0",
    "nodemon": "~2.0.12",
    "postcss-cli": "~9.0.0",
    "postcss-import": "~12.0.1",
    "query-string": "~7.0.1",
    "shx": "~0.3.4",
    "tap": "~15.0.9"
  },
  "engines": {
    "node": ">=10.0",
    "npm": ">=4.0"
  },
  "files": [
    "CHANGELOG.md",
    "CHANGELOG.json",
    "README.md",
    "LOOKUP-CACHE.md",
    "aeppic-server.service",
    "assets",
    "example-client.js",
    "bin",
    "dist",
    "runtime",
    "src",
    "server",
    "utils",
    "webroot",
    "server.json",
    "services.sh",
    "COMPONENT-PRELOAD.md"
  ],
  "name": "@aeppic/server",
  "private": false,
  "publishConfig": {
    "registry": "https://npm.curasystems.com/"
  },
  "scripts": {
    "build": "rimraf dist && npm run compile && node build/build.js",
    "build:incremental": "npm run compile && node build/build.js",
    "compile": "npm run compile:css && npm run compile:copy-sqlite && npm run compile:copy-aeppic-worker && npm run compile:copy-read-model-browser 2>&1 && npm run compile:copy-service-worker",
    "compile:copy-aeppic-worker": "shx mkdir -p ./webroot/libs/aeppic && shx cp node_modules/aeppic/dist/aeppic-offline-store-worker.js ./webroot/libs/aeppic/",
    "compile:copy-read-model-browser": "rimraf ./webroot/libs/read-model-browser && shx mkdir -p ./webroot/libs/read-model-browser && shx cp -r node_modules/@aeppic/read-model-browser/dist/* ./webroot/libs/read-model-browser/",
    "compile:copy-service-worker": "node build/copy-service-worker.mjs",
    "compile:copy-sqlite": "rimraf ./webroot/libs/sqlite && shx mkdir -p ./webroot/libs/sqlite && shx cp node_modules/@sqlite.org/sqlite-wasm/sqlite-wasm/jswasm/* ./webroot/libs/sqlite/",
    "compile:css": "npm run compile:css:main && npm run compile:css:loading",
    "compile:css:loading": "postcss src/loading.css -o dist/loading.css",
    "compile:css:main": "postcss src/main.css -o dist/main.css",
    "compile:watch": "nodemon -e css -w src -w tailwindcss-config.cjs -w postcss.config.cjs --exec npm run compile",
    "dev": "cross-env NODE_ENV=development IMPERSONATION_FIXED_PW=test888test888 node $(node --v8-options | sed -n 's/.*--experimental-wasm-reftypes .*/--experimental-wasm-reftypes/p') --trace-deprecation --gc-interval=250 --max-old-space-size=8192 --max-semi-space-size=256 --nouse-idle-notification --expose-gc --inspect bin/aeppic-server ",
    "dev:stage": "cross-env NODE_ENV=development IMPERSONATION_FIXED_PW=test888test888 sh -c 'server_config=\"$npm_config_server_config\"; if [ \"$server_config\" = true ]; then server_config=\"$1\"; shift; fi; if [ -n \"$server_config\" ] && [ \"$server_config\" != false ]; then set -- \"--config=$server_config\" \"$@\"; fi; exec node $(node --v8-options | sed -n \"s/.*--experimental-wasm-reftypes .*/--experimental-wasm-reftypes/p\") --trace-deprecation --gc-interval=250 --max-old-space-size=8192 --max-semi-space-size=256 --nouse-idle-notification --expose-gc --inspect bin/aeppic-server --source-data-dir=/opt/aeppic/data --data-dir=/opt/aeppic/data/staging/$npm_config_stage \"$@\"' --",
    "dev:stage:docker": "([ \"$npm_config_pull\" = \"true\" ] && docker pull registry.dev.curasystems.com/aeppic/aeppic-full/server:$npm_config_tag || true) && docker run -it --rm -p 8088:8088 --mount type=bind,source=/opt/aeppic/data,target=/opt/aeppic/data --mount type=bind,source=$PWD/etc-$npm_config_stage,target=/etc/opt/aeppic -e NODE_ENV=development -e IMPERSONATION_FIXED_PW=test888test888 registry.dev.curasystems.com/aeppic/aeppic-full/server:$npm_config_tag npm start -- --config=/etc/opt/aeppic/server.json --source-data-dir=/opt/aeppic/data --data-dir=/opt/aeppic/data/staging/$npm_config_stage",
    "image:build": "npm run image:gather-deploy && npm run image:create-builder && npm run image:build:buildx-multiarch",
    "image:build:amd64": "cross-env ARCH=amd64 npm run image:build:arch",
    "image:build:arch": "            cross-var docker build        --pull --progress=plain  --platform linux/${ARCH} --build-arg MAINTAINER_EMAIL=$npm_package_config_email --build-arg IMAGE_NAME=$npm_package_name --tag $npm_package_config_docker_tag .",
    "image:build:arm64/v8": "cross-env ARCH=arm64/v8 npm run image:build:arch",
    "image:build:buildx-multiarch": "cross-var docker buildx build --progress=plain --pull --push --provenance=false --platform linux/amd64,linux/arm64/v8 --build-arg MAINTAINER_EMAIL=$npm_package_config_email --build-arg IMAGE_NAME=$npm_package_name --tag $npm_config_docker_tag --builder multiplatform_builder .",
    "image:create-builder": "docker buildx create --name multiplatform_builder --driver docker-container || true",
    "image:gather-deploy": "npm run image:remove-python3-links && mkdir -p deploy && node ../../common/scripts/install-run-rush.js deploy -p @aeppic/server --overwrite --target-folder ./deploy",
    "image:remove-python3-links": "cd ../.. && find . -type l -iname 'python3*' | xargs -I {} rm {}",
    "image:run:arm64/v8": "docker run -it --rm -p 8088:8088 --mount type=bind,source=/opt/aeppic/data,target=/opt/aeppic/data --mount type=bind,source=/etc/opt/aeppic,target=/etc/opt/aeppic  --platform linux/arm64/v8 registry.dev.curasystems.com/aeppic/aeppic-full/server:dev",
    "keycloak:restart": "bash test/saml/start-keycloak.sh restart",
    "keycloak:start": "bash test/saml/start-keycloak.sh start",
    "keycloak:stop": "bash test/saml/start-keycloak.sh stop",
    "start": "node --inspect --trace-warnings bin/aeppic-server.js",
    "test": "rimraf test/output && npm run test:unit | faucet && npm run test:playwright",
    "test:boot-sync": "node test/boot-sync/run.mjs",
    "test:ci": "rimraf test/output && npm run test:unit-ci && PW_TEST_HTML_REPORT_OPEN='never' npm run test:playwright 2>&1",
    "test:playwright": "true || playwright test",
    "test:server": "tap --no-coverage server/*.spec.js",
    "test:server:watch": "tap --no-check-coverage --watch server/*.spec.js",
    "test:unit": "rimraf test/output/*.json && cross-var c8 tap --no-cov $npm_package_config_filter",
    "test:unit-ci": "rimraf test/output/*.json && c8 tap --no-cov test/server/*.spec.js 2>&1",
    "test:unit:watch": "rimraf test/output/*.json && nodemon --exec cross-var c8 tap --no-cov --reporter=specy $npm_package_config_filter | pino-pretty",
    "trace": "cross-env NODE_ENV=development IMPERSONATION_FIXED_PW=test888test888 dexnode --redirect-code-traces-to=./trace.tmp --gc-interval=250 --max-old-space-size=8192 --max-semi-space-size=256 --nouse-idle-notification --expose-gc bin/aeppic-server"
  },
  "type": "module",
  "version": "3.206.38"
}
